import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-offline-dialog',
  template: `
    <h3>You are offline</h3>
    <p>Please check your Internet connection.</p>
  `,
  styles: [``]
})
export class OfflineDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/offline-dialog.component.ts